import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Locales from "./locales";
import { useAuthStore } from "./stores/authStore";

void i18next.use(initReactI18next).init({
  resources: Locales.resources,
  lng: useAuthStore.getState().locale,
  fallbackLng: Locales.fallbackLng,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export const t = i18next.t.bind(i18next) as (
  key: string,
  options?: Record<string, unknown>,
) => string;

export default i18next;
